import { render } from "./DotLoader.vue?vue&type=template&id=132d719a"
import script from "./DotLoader.vue?vue&type=script&lang=js"
export * from "./DotLoader.vue?vue&type=script&lang=js"

import "./DotLoader.vue?vue&type=style&index=0&id=132d719a&lang=css"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__